import api from "../api/api";

// import axios from "axios";
// import { auth } from "../firebase";

// const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:4000";

// const api = axios.create({
//   baseURL: API_BASE_URL,
//   timeout: 30000,
// });

// api.interceptors.request.use(
//   async (config) => {
//     const user = auth.currentUser;
//     if (user) {
//       try {
//         const idToken = await user.getIdToken();
//         config.headers.Authorization = `Bearer ${idToken}`;
//       } catch (error) {
//         console.error("Error getting auth token:", error);
//       }
//     }
//     return config;
//   },
//   (error) => {
//     return Promise.reject(error);
//   },
// );

api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    console.error(
      `❌ API Error: ${error.config?.method?.toUpperCase()} ${
        error.config?.url
      }`,
      error.response?.data || error.message
    );

    if (error.response?.status === 401) {
      window.location.href = "/login";
    }

    return Promise.reject(error);
  }
);

const companyService = {
  // GET /company
  getAllCompanies: async (params) => {
    const response = await api.get("/company", { params });
    return response;
  },

  // GET /company/:id
  getCompanyById: async (id) => {
    const response = await api.get(`/company/${id}`);
    return response;
  },

  // POST /company
  createCompany: async (companyData) => {
    const response = await api.post("/company", companyData);
    return response.data;
  },

  // PATCH /company/:id
  updateCompany: async (companyId, updateData) => {
    const response = await api.patch(`/company/${companyId}`, updateData);
    return response.data;
  },

  // DELETE /company/:id
  deleteCompany: async (companyId) => {
    const response = await api.delete(`/company/${companyId}`);
    return response.data;
  },

  // POST /company/autoCreate (Sync from Dataverse)
  syncFromDataverse: async () => {
    const response = await api.post("/company/autoCreate");
    return response.data;
  },
};

export default companyService;
